import React from "react";

import {
    FaUserTie,
    FaUserCheck,
    FaUserTimes,
    FaTasks,
    FaExclamationTriangle,
} from "react-icons/fa";

import SectionCard from "./SectionCard";

import {
    formatNumber,
} from "../utils/dashboardFormatters";


const EmployeeOverview = ({
    employees = {},
    tasks = {},
}) => {

    const items = [
        {
            title: "Total Employees",
            value: employees?.totalEmployees,
            icon: FaUserTie,
        },

        {
            title: "Active Employees",
            value: employees?.activeEmployees,
            icon: FaUserCheck,
        },

        {
            title: "Inactive / Pending",
            value: employees?.inactiveEmployees,
            icon: FaUserTimes,
        },

        {
            title: "Open Tasks",
            value: tasks?.openTasks,
            icon: FaTasks,
        },

        {
            title: "Overdue Tasks",
            value: tasks?.overdue,
            icon: FaExclamationTriangle,
            danger: true,
        },
    ];


    return (

        <SectionCard
            title="Employee Management"
            subtitle="Employee status and workload overview."
        >

            <div className="dashboard-employee-grid">

                {
                    items.map(
                        (
                            item
                        ) => {

                            const Icon =
                                item.icon;


                            return (

                                <div
                                    key={
                                        item.title
                                    }

                                    className={
                                        item.danger
                                            ? "dashboard-employee-stat dashboard-employee-stat--danger"
                                            : "dashboard-employee-stat"
                                    }
                                >

                                    <Icon />


                                    <div>

                                        <span>
                                            {
                                                item.title
                                            }
                                        </span>


                                        <strong>
                                            {
                                                formatNumber(
                                                    item.value
                                                )
                                            }
                                        </strong>

                                    </div>

                                </div>

                            );

                        }
                    )
                }

            </div>

        </SectionCard>

    );

};


export default EmployeeOverview;